
export class InteractWithDocumentFirstException extends Error
{
    constructor()
    {
        super("Click anything to play");
    }
}
